(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-internal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    console.log("TEST:: Video background section initialized");
    
    // Make sure video takes up full width/height
    const videoElements = document.querySelectorAll('.video-internal-mp4');
    videoElements.forEach(video => {
      // Force play in case autoplay fails
      video.play().catch(error => {
        console.log("TEST:: Video autoplay failed, trying muted:", error);
        video.muted = true;
        video.play().catch(e => console.error(e));
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
